export { getAdminUrl } from './get-admin-url';
